export const MIN_SEARCH_LENGTH_FOR_SELECT_ALL = 2;
